import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  signal,
} from "@angular/core";

import { ColDef } from "ag-grid-enterprise";

import { LinkCellRendererComponent } from "@shared/cell-renderers";
import { TextConstants } from "@shared/constants";
import { TableEnum } from "@shared/enums";
import { IMissingDocumentType } from "@shared/interfaces";
import { AuthenticationService } from "@shared/services";
import { RouterService } from "@shared/services/router.service";
import { CommonUtils } from "@shared/utils";

@Component({
  standalone: false,
  selector: "app-missing-document-types-table",
  templateUrl: "./missing-document-types-table.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MissingDocumentTypesTableComponent implements AfterViewInit {
  rowData = input.required<IMissingDocumentType[]>();

  areButtonsEnabled = input<boolean>(true);

  isSearchEnabled = input<boolean>(true);

  isPaginatorEnabled = input<boolean>(true);

  isFixedBottomPaginator = input<boolean>(false);

  columns = input<string[]>(["types", "ruleset.name"]);

  columnDefs = signal<ColDef[]>([]);

  readonly table = TableEnum.MISSING_DOCUMENT_TYPES;

  private readonly routerService = inject(RouterService);

  private readonly authenticationService = inject(AuthenticationService);

  private readonly canAccessRulesets = this.authenticationService.canAccessRulesets;

  async ngAfterViewInit() {
    this.setColumnDefs();
  }

  private setColumnDefs(): void {
    let rulesetNameColumnDef: ColDef = {
      headerName: TextConstants.RULESET,
      field: "ruleset.name",
    };

    if (this.canAccessRulesets) {
      rulesetNameColumnDef = {
        ...rulesetNameColumnDef,
        cellRenderer: LinkCellRendererComponent,
        cellRendererParams: {
          linkRouteFn: this.routerService.getRulesetLink,
          linkRouteIdParam: "ruleset.id",
          openInNewTab: true,
        },
      };
    }

    let columnDefs: ColDef[] = [
      {
        headerName: TextConstants.TYPE,
        field: "types",
        lockVisible: true,
      },
      rulesetNameColumnDef,
    ];

    columnDefs = CommonUtils.getVisibleColumnDefs(columnDefs, this.columns());

    this.columnDefs.set(columnDefs);
  }
}
